module.exports = __webpack_public_path__ + "img/loading1.2c5a040d.gif";